<template>
    <div class="pp-home">

        <!-- =======================================
         NEW PREMIUM HERO
    ======================================== -->
        <section class="pp-hero" :style="{ backgroundImage: `url('${heroBg}')` }">
            <div class="pp-hero-shade"></div>

            <div class="container pp-hero-container">

                <!-- HERO CONTENT -->
                <div class="pp-hero-top">

                    <!-- LEFT TITLE -->
                    <div class="pp-hero-heading">
                        <span class="pp-hero-eyebrow">
                            VOTRE SPÉCIALISTE DU PNEU EN LIGNE
                        </span>

                        <h1>
                            Prenez la route
                            <span>en toute confiance</span>
                        </h1>

                        <p>
                            Trouvez les pneus adaptés à votre véhicule,
                            comparez les marques et choisissez selon votre budget.
                        </p>
                    </div>

                    <!-- RIGHT ADVANTAGES -->
                    <div class="pp-hero-benefits">

                        <div class="pp-hero-benefit">
                            <div class="pp-benefit-icon">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="9" />
                                    <path d="m7.5 12 3 3 6-6" />
                                </svg>
                            </div>

                            <span>
                                <strong>De grandes marques</strong>
                                <small>Pour chaque budget</small>
                            </span>
                        </div>

                        <div class="pp-hero-benefit">
                            <div class="pp-benefit-icon">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <path d="M3 7h11v10H3z" />
                                    <path d="M14 10h4l3 4v3h-7z" />
                                    <circle cx="7" cy="18" r="2" />
                                    <circle cx="18" cy="18" r="2" />
                                </svg>
                            </div>

                            <span>
                                <strong>Livraison de pneus</strong>
                                <small>Selon votre destination</small>
                            </span>
                        </div>

                        <div class="pp-hero-benefit">
                            <div class="pp-benefit-icon orange">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <path d="M12 2 4 6v6c0 5 3.4 8.3 8 10 4.6-1.7 8-5 8-10V6z" />
                                    <path d="m8.5 12 2.5 2.5 4.5-5" />
                                </svg>
                            </div>

                            <span>
                                <strong>Choisissez sereinement</strong>
                                <small>Dimensions et caractéristiques</small>
                            </span>
                        </div>

                    </div>

                </div>

                <!-- =======================================
             TIRE SEARCH BOX
        ======================================== -->
                <div class="pp-search-widget">

                    <!-- TABS -->
                    <div class="pp-search-tabs">

                        <button type="button" class="pp-search-tab" :class="{ active: activeTab === 'dimension' }"
                            @click="activeTab = 'dimension'">
                            <svg viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="12" r="9" />
                                <circle cx="12" cy="12" r="4.5" />
                                <path d="M12 3v4.5M12 16.5V21M3 12h4.5M16.5 12H21" />
                            </svg>
                            <span>Recherche par dimension</span>
                        </button>

                        <button type="button" class="pp-search-tab" :class="{ active: activeTab === 'vehicle' }"
                            @click="activeTab = 'vehicle'">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path d="M5 15 3 13l2-7h14l2 7-2 2" />
                                <path d="M3 13h18v5H3z" />
                                <circle cx="7" cy="18" r="1" />
                                <circle cx="17" cy="18" r="1" />
                                <path d="M6 10h12" />
                            </svg>
                            <span>Recherche par véhicule</span>
                        </button>

                    </div>

                    <!-- WHITE PANEL -->
                    <div class="pp-search-card">

                        <!-- SEARCH BY DIMENSION -->
                        <form v-if="activeTab === 'dimension'" class="pp-search-form" @submit.prevent="submitForm">

                            <div class="pp-form-grid">

                                <div class="pp-field">
                                    <label for="pp-width">Largeur</label>
                                    <select id="pp-width" v-model="filters.width">
                                        <option value="">Toutes</option>
                                        <option v-for="value in widths" :key="value" :value="String(value)">
                                            {{ value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="pp-field">
                                    <label for="pp-height">Hauteur</label>
                                    <select id="pp-height" v-model="filters.height">
                                        <option value="">Toutes</option>
                                        <option v-for="value in heights" :key="value" :value="String(value)">
                                            {{ value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="pp-field">
                                    <label for="pp-diameter">Diamètre</label>
                                    <select id="pp-diameter" v-model="filters.diameter">
                                        <option value="">Tous</option>
                                        <option v-for="value in diameters" :key="value" :value="String(value)">
                                            {{ value }}
                                        </option>
                                    </select>
                                </div>

                                <div class="pp-field">
                                    <label for="pp-brand">Marque</label>
                                    <select id="pp-brand" v-model="filters.brand">
                                        <option value="">Toutes les marques</option>
                                        <option v-for="brand in brands" :key="brand" :value="brand">
                                            {{ brand }}
                                        </option>
                                    </select>
                                </div>

                                <div class="pp-field">
                                    <label for="pp-season">Saison</label>
                                    <select id="pp-season" v-model="filters.season">
                                        <option value="">Tous les pneus</option>
                                        <option value="summer">Pneus été</option>
                                        <option value="winter">Pneus hiver</option>
                                        <option value="all-season">4 saisons</option>
                                    </select>
                                </div>

                                <div class="pp-field pp-field-submit">
                                    <label class="pp-submit-spacer" aria-hidden="true">
                                        Rechercher
                                    </label>
                                    <button type="submit" class="pp-search-submit">
                                        Voir les pneus
                                        <svg viewBox="0 0 24 24" fill="none">
                                            <path d="M4 12h16M13 5l7 7-7 7" />
                                        </svg>
                                    </button>
                                </div>

                            </div>

                            <!-- FOOTER -->
                            <div class="pp-search-footer">

                                <div class="pp-search-helper">
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <circle cx="12" cy="12" r="9" />
                                        <path d="M9.5 9a2.5 2.5 0 1 1 4.5 1.5c-1.3 1.2-2 1.5-2 3" />
                                        <circle cx="12" cy="17" r=".7" fill="currentColor" stroke="none" />
                                    </svg>

                                    <button type="button" @click="showSizeHelp = !showSizeHelp">
                                        Où trouver mes dimensions ?
                                    </button>
                                </div>

                                <div class="pp-secure-note">
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <path d="M12 2 4 6v6c0 5 3.4 8.3 8 10 4.6-1.7 8-5 8-10V6z" />
                                        <path d="m8.5 12 2.5 2.5 4.5-5" />
                                    </svg>
                                    Recherche simple et rapide
                                </div>

                            </div>

                            <!-- DIMENSION HELP -->
                            <div v-if="showSizeHelp" class="pp-dimension-help">
                                <div>
                                    <strong>Comment lire une dimension de pneu ?</strong>
                                    <p>
                                        Exemple : <b>205/55 R16</b> — 205 correspond
                                        à la largeur en millimètres, 55 au rapport
                                        hauteur/largeur et 16 au diamètre de la jante
                                        en pouces.
                                    </p>
                                    <p>
                                        Vous trouverez cette inscription sur le flanc
                                        de votre pneu. Vérifiez toujours les dimensions
                                        homologuées pour votre véhicule.
                                    </p>
                                </div>
                                <span class="pp-size-example">205 / 55 R16</span>
                            </div>

                        </form>

                        <!-- SEARCH BY VEHICLE: DESIGN PREVIEW -->
                        <div v-else class="pp-vehicle-search">
                            <div class="pp-vehicle-icon">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <path d="M5 15 3 13l2-7h14l2 7-2 2" />
                                    <path d="M3 13h18v5H3z" />
                                    <circle cx="7" cy="18" r="1" />
                                    <circle cx="17" cy="18" r="1" />
                                </svg>
                            </div>

                            <div class="pp-vehicle-copy">
                                <h3>Recherche par véhicule</h3>
                                <p>
                                    Cette recherche sera disponible après
                                    l'intégration du catalogue de compatibilité.
                                    Pour le moment, recherchez vos pneus par dimension.
                                </p>
                            </div>

                            <button type="button" class="pp-vehicle-back" @click="activeTab = 'dimension'">
                                Rechercher par dimension
                                <span>→</span>
                            </button>
                        </div>

                    </div>
                </div>

            </div>
        </section>

        <!-- =======================================
         REASSURANCE STRIP
    ======================================== -->
        <section class="pp-trust-bar">
            <div class="container">
                <div class="pp-trust-grid">

                    <div class="pp-trust-item">
                        <div class="pp-trust-icon">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path d="M2 6h12v11H2z" />
                                <path d="M14 9h4l4 5v3h-8z" />
                                <circle cx="6" cy="18" r="2" />
                                <circle cx="18" cy="18" r="2" />
                                <path d="M1 10h8M1 13h6" />
                            </svg>
                        </div>
                        <div>
                            <h3>Livraison de pneus</h3>
                            <p>Des options selon votre adresse</p>
                        </div>
                    </div>

                    <div class="pp-trust-item">
                        <div class="pp-trust-icon">
                            <svg viewBox="0 0 24 24" fill="none">
                                <rect x="5" y="10" width="14" height="11" rx="2" />
                                <path d="M8 10V7a4 4 0 0 1 8 0v3" />
                                <path d="M12 14v3" />
                            </svg>
                        </div>
                        <div>
                            <h3>Achat sécurisé</h3>
                            <p>Un parcours de commande protégé</p>
                        </div>
                    </div>

                    <div class="pp-trust-item">
                        <div class="pp-trust-icon">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path d="m4 20 9-9M14 5l5 5" />
                                <path d="M15 3a5 5 0 0 0-5 6l5 5a5 5 0 0 0 6-5l-3 2-4-4z" />
                                <path d="M3 16l5 5" />
                            </svg>
                        </div>
                        <div>
                            <h3>Solutions de montage</h3>
                            <p>Pour faciliter le changement de pneus</p>
                        </div>
                    </div>

                    <div class="pp-trust-item">
                        <div class="pp-trust-icon">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path d="M4 13v-2a8 8 0 0 1 16 0v2" />
                                <rect x="2" y="12" width="4" height="7" rx="2" />
                                <rect x="18" y="12" width="4" height="7" rx="2" />
                                <path d="M20 19c0 3-4 3-7 3" />
                            </svg>
                        </div>
                        <div>
                            <h3>À votre écoute</h3>
                            <p>Une question sur votre commande ?</p>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <!-- Brands -->
        <HomeBrands />

        <!-- Featured products -->
        <FeaturedProducts />

        <!-- 1. Mounting options -->
        <MontageOptions />

        <!-- 2. Three steps -->
        <HowItWorks />

        <!-- 3. Why ProduPneu -->
        <HomeWhyUs />

        <!-- 4. Customer reviews -->
        <Testimonials />

    </div>
</template>

<script>
import HomeBrands from "../../components/home/Brands.vue";
import FeaturedProducts from "../../components/home/FeaturedProducts.vue";
import MontageOptions from "../../components/home/MontageOptions.vue";
import HowItWorks from "../../components/home/HowItWorks.vue";
import HomeWhyUs from "../../components/home/WhyUs.vue";
import Testimonials from "../../components/home/Testimonials.vue";

export default {
    name: "Home",

    components: {
        HomeBrands,
        FeaturedProducts,
        MontageOptions,
        HowItWorks,
        HomeWhyUs,
        Testimonials,
    },

    data() {
        return {
            // Existing image path from your project.
            // Replace with the new road/car hero image
            // once you add it to public/assets/images/.
            heroBg: "/assets/images/image-bg-car.png",

            activeTab: "dimension",
            showSizeHelp: false,

            filters: {
                width: "205",
                height: "55",
                diameter: "16",
                brand: "",
                season: "",
            },

            widths: [
                155, 165, 175, 185, 195, 205,
                215, 225, 235, 245, 255, 265,
                275, 285, 295, 305
            ],

            heights: [
                30, 35, 40, 45, 50, 55,
                60, 65, 70, 75, 80
            ],

            diameters: [
                13, 14, 15, 16, 17, 18,
                19, 20, 21, 22, 23
            ],

            brands: [
                "Michelin",
                "Continental",
                "Bridgestone",
                "Goodyear",
                "Pirelli",
                "Hankook",
                "Dunlop",
                "Kleber",
                "Kumho",
                "Nexen",
            ],
        };
    },

    methods: {
        submitForm() {
            const query = {};

            Object.keys(this.filters).forEach((key) => {
                const value = this.filters[key];

                if (value !== "" && value !== null) {
                    query[key] = String(value);
                }
            });

            this.$router.push({
                name: "products",
                query,
            }).catch((error) => {
                if (error.name !== "NavigationDuplicated") {
                    console.error(error);
                }
            });
        },
    },
};
</script>

<style scoped>
/* =============================================
   PRODU PNEU — NEW HOMEPAGE
   Orange: #ff7900
   Dark:   #151a20
============================================= */

.pp-home {
    --pp-orange: #ff7900;
    --pp-orange-dark: #e86d00;
    --pp-dark: #151a20;
    --pp-muted: #7c858e;

    width: 100%;
    overflow: hidden;
    font-family: "Poppins", sans-serif;
}

.pp-home *,
.pp-home *::before,
.pp-home *::after {
    box-sizing: border-box;
}

.pp-home svg {
    stroke: currentColor;
    stroke-width: 1.9;
    stroke-linecap: round;
    stroke-linejoin: round;
}

/* =============================================
   HERO BACKGROUND
============================================= */

.pp-hero {
    position: relative;
    background-color: #202329;
    background-size: cover;
    background-position: center 48%;
    background-repeat: no-repeat;
    min-height: 570px;
    padding: 52px 0 43px;
    isolation: isolate;
}

.pp-hero-shade {
    position: absolute;
    z-index: -1;
    inset: 0;
    background:
        linear-gradient(90deg,
            rgba(9, 12, 16, .82) 0%,
            rgba(9, 12, 16, .57) 35%,
            rgba(9, 12, 16, .08) 65%,
            rgba(9, 12, 16, .56) 100%),
        linear-gradient(180deg,
            rgba(5, 8, 12, .03) 25%,
            rgba(5, 8, 12, .75) 100%);
}

.pp-hero-container {
    position: relative;
    z-index: 2;
}

/* =============================================
   HERO TOP CONTENT
============================================= */

.pp-hero-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 45px;
    margin-bottom: 45px;
}

.pp-hero-heading {
    max-width: 720px;
}

.pp-hero-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 2px;
    margin-bottom: 15px;
}

.pp-hero-eyebrow::before {
    content: "";
    width: 25px;
    height: 2px;
    background: var(--pp-orange);
}

.pp-hero-heading h1 {
    margin: 0;
    color: #fff;
    font-size: clamp(38px, 4vw, 62px);
    font-weight: 900;
    line-height: 1.13;
    letter-spacing: -2px;
    text-shadow: 0 3px 15px rgba(0, 0, 0, .3);
}

.pp-hero-heading h1 span {
    display: block;
    color: #ff9225;
}

.pp-hero-heading p {
    color: #f1f2f3;
    font-size: 16px;
    line-height: 1.7;
    font-weight: 500;
    margin: 17px 0 0;
    max-width: 580px;
    text-shadow: 0 2px 8px rgba(0, 0, 0, .4);
}

/* =============================================
   HERO ADVANTAGES
============================================= */

.pp-hero-benefits {
    width: 250px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 0;
    background: rgba(10, 13, 17, .25);
    border-radius: 12px;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
}

.pp-hero-benefit {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 17px 13px;
}

.pp-hero-benefit+.pp-hero-benefit {
    border-top: 1px solid rgba(255, 255, 255, .13);
}

.pp-benefit-icon {
    width: 38px;
    height: 38px;
    flex-shrink: 0;
    color: #fff;
}

.pp-benefit-icon.orange {
    color: var(--pp-orange);
}

.pp-benefit-icon svg {
    width: 100%;
    height: 100%;
}

.pp-hero-benefit span {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.pp-hero-benefit strong {
    color: #fff;
    font-size: 12px;
    font-weight: 800;
    line-height: 1.4;
}

.pp-hero-benefit small {
    color: #e2e4e6;
    font-size: 11px;
    line-height: 1.5;
}

/* =============================================
   SEARCH WIDGET
============================================= */

.pp-search-widget {
    width: 100%;
    position: relative;
}

.pp-search-tabs {
    display: flex;
    align-items: flex-end;
    gap: 0;
}

.pp-search-tab {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    width: 310px;
    max-width: 50%;
    height: 64px;
    padding: 0 35px 0 20px;
    border: 0;
    border-radius: 13px 13px 0 0;
    background: rgba(19, 23, 28, .78);
    color: #f1f3f5;
    font-size: 13px;
    font-weight: 800;
    cursor: pointer;
    transition: background .2s, color .2s;
}

.pp-search-tab:first-child {
    clip-path: polygon(0 0,
            92% 0,
            100% 100%,
            0 100%);
}

.pp-search-tab:nth-child(2) {
    margin-left: -15px;
    padding-left: 33px;
    clip-path: polygon(0 0,
            92% 0,
            100% 100%,
            8% 100%);
}

.pp-search-tab svg {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
}

.pp-search-tab.active {
    background: #fff;
    color: #20252a;
    z-index: 2;
}

.pp-search-tab.active::after {
    content: "";
    position: absolute;
    left: 23px;
    right: 40px;
    bottom: 0;
    height: 3px;
    background: var(--pp-orange);
}

.pp-search-tab:not(.active):hover {
    background: rgba(40, 45, 50, .95);
}

/* WHITE PANEL */

.pp-search-card {
    background: #fff;
    border-radius: 0 13px 13px 13px;
    padding: 29px 28px 19px;
    box-shadow: 0 17px 45px rgba(0, 0, 0, .23);
}

.pp-search-form {
    margin: 0;
}

/* FORM GRID */

.pp-form-grid {
    display: grid;
    grid-template-columns:
        1fr 1fr 1fr 1.5fr 1.5fr 1.35fr;
    align-items: end;
    gap: 16px;
}

.pp-field {
    min-width: 0;
}

.pp-field label {
    display: block;
    color: #30353b;
    font-size: 12px;
    font-weight: 800;
    margin-bottom: 10px;
}

.pp-field select {
    display: block;
    width: 100%;
    height: 53px;
    padding: 0 12px;
    border: 1px solid #dde2e6;
    border-radius: 8px;
    background-color: #fff;
    color: #333b42;
    font-family: inherit;
    font-size: 12px;
    outline: none;
    cursor: pointer;
    transition: border .2s, box-shadow .2s;
}

.pp-field select:focus {
    border-color: var(--pp-orange);
    box-shadow: 0 0 0 3px rgba(255, 121, 0, .12);
}

.pp-field-submit .pp-submit-spacer {
    visibility: hidden;
}

/* SEARCH BUTTON */

.pp-search-submit {
    width: 100%;
    height: 53px;
    padding: 0 15px;
    border: 0;
    border-radius: 8px;
    background: var(--pp-orange);
    color: #fff;
    font-family: inherit;
    font-size: 14px;
    font-weight: 900;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    cursor: pointer;
    white-space: nowrap;
    box-shadow: 0 5px 12px rgba(255, 121, 0, .18);
    transition: background .25s, transform .25s;
}

.pp-search-submit:hover {
    background: var(--pp-orange-dark);
    transform: translateY(-2px);
}

.pp-search-submit svg {
    width: 20px;
    height: 20px;
    transition: transform .25s;
}

.pp-search-submit:hover svg {
    transform: translateX(4px);
}

/* SEARCH FOOTER */

.pp-search-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    margin-top: 18px;
}

.pp-search-helper {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.pp-search-helper svg {
    width: 18px;
    height: 18px;
    color: #343a40;
}

.pp-search-helper button {
    border: 0;
    padding: 0;
    background: none;
    color: #626971;
    font-size: 11px;
    text-decoration: underline;
    cursor: pointer;
}

.pp-search-helper button:hover {
    color: var(--pp-orange);
}

.pp-secure-note {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #5e6670;
    font-size: 11px;
}

.pp-secure-note svg {
    width: 19px;
    height: 19px;
    color: #27884c;
}

/* DIMENSIONS HELP */

.pp-dimension-help {
    margin-top: 18px;
    padding: 18px 22px;
    border: 1px solid #ffdec1;
    border-radius: 9px;
    background: #fff9f3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 25px;
}

.pp-dimension-help strong {
    display: block;
    color: #30343a;
    font-size: 13px;
    margin-bottom: 8px;
}

.pp-dimension-help p {
    color: #69717a;
    font-size: 11px;
    line-height: 1.8;
    margin: 5px 0;
}

.pp-size-example {
    flex-shrink: 0;
    color: var(--pp-orange);
    font-size: 22px;
    font-weight: 900;
    white-space: nowrap;
}

/* VEHICLE TAB */

.pp-vehicle-search {
    min-height: 133px;
    display: flex;
    align-items: center;
    gap: 20px;
}

.pp-vehicle-icon {
    color: var(--pp-orange);
    width: 52px;
    height: 52px;
    flex-shrink: 0;
}

.pp-vehicle-icon svg {
    width: 100%;
    height: 100%;
}

.pp-vehicle-copy {
    flex: 1;
}

.pp-vehicle-copy h3 {
    color: #23272c;
    font-size: 18px;
    font-weight: 850;
    margin: 0 0 7px;
}

.pp-vehicle-copy p {
    color: #717a84;
    font-size: 12px;
    line-height: 1.8;
    margin: 0;
}

.pp-vehicle-back {
    flex-shrink: 0;
    border: 0;
    border-radius: 8px;
    background: var(--pp-orange);
    color: #fff;
    padding: 15px 18px;
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
}

/* =============================================
   REASSURANCE STRIP
============================================= */

.pp-trust-bar {
    position: relative;
    background: #fff;
    border-bottom: 1px solid #e9ecef;
    padding: 30px 0;
}

.pp-trust-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.pp-trust-item {
    display: flex;
    align-items: center;
    gap: 15px;
    min-width: 0;
    padding: 8px 20px;
}

.pp-trust-item:first-child {
    padding-left: 0;
}

.pp-trust-item+.pp-trust-item {
    border-left: 1px solid #e7e9ec;
}

.pp-trust-icon {
    flex-shrink: 0;
    width: 43px;
    height: 43px;
    color: var(--pp-orange);
}

.pp-trust-icon svg {
    width: 100%;
    height: 100%;
}

.pp-trust-item h3 {
    color: #23282e;
    font-size: 12px;
    font-weight: 800;
    line-height: 1.4;
    margin: 0 0 5px;
}

.pp-trust-item p {
    color: #89919a;
    font-size: 11px;
    line-height: 1.6;
    margin: 0;
}

/* =============================================
   RESPONSIVE
============================================= */

@media (min-width: 1400px) {
    .pp-hero {
        min-height: 625px;
        padding-top: 64px;
    }

    .pp-hero-top {
        margin-bottom: 55px;
    }
}

@media (max-width: 1199px) {
    .pp-hero {
        padding-top: 50px;
    }

    .pp-hero-heading h1 {
        font-size: 45px;
    }

    .pp-hero-benefits {
        width: 215px;
    }

    .pp-form-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 17px;
    }

    .pp-trust-item {
        padding: 8px 12px;
        gap: 10px;
    }

    .pp-trust-icon {
        width: 35px;
        height: 35px;
    }
}

@media (max-width: 991px) {
    .pp-hero {
        min-height: auto;
        background-position: 60% center;
        padding: 55px 0 40px;
    }

    .pp-hero-top {
        align-items: flex-start;
        flex-direction: column;
        gap: 25px;
        margin-bottom: 35px;
    }

    .pp-hero-heading {
        max-width: 680px;
    }

    .pp-hero-heading h1 {
        font-size: 46px;
    }

    .pp-hero-benefits {
        width: 100%;
        flex-direction: row;
        justify-content: space-between;
        background: rgba(12, 16, 21, .65);
    }

    .pp-hero-benefit {
        flex: 1;
        padding: 15px 10px;
    }

    .pp-hero-benefit+.pp-hero-benefit {
        border-top: 0;
        border-left: 1px solid rgba(255, 255, 255, .14);
    }

    .pp-trust-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 15px 0;
    }

    .pp-trust-item:nth-child(3) {
        border-left: 0;
        padding-left: 0;
    }
}

@media (max-width: 767px) {
    .pp-hero {
        padding: 40px 0 28px;
        background-position: 65% center;
    }

    .pp-hero-heading h1 {
        font-size: 37px;
        letter-spacing: -1.2px;
    }

    .pp-hero-heading p {
        font-size: 13px;
        line-height: 1.8;
    }

    .pp-hero-eyebrow {
        font-size: 9px;
        letter-spacing: 1px;
    }

    .pp-hero-benefits {
        flex-wrap: wrap;
    }

    .pp-hero-benefit {
        flex: 1 1 100%;
        gap: 12px;
        padding: 10px 15px;
    }

    .pp-hero-benefit+.pp-hero-benefit {
        border-left: 0;
        border-top: 1px solid rgba(255, 255, 255, .12);
    }

    .pp-benefit-icon {
        width: 25px;
        height: 25px;
    }

    .pp-search-tab {
        width: 50%;
        height: 58px;
        gap: 8px;
        padding: 0 16px;
        font-size: 10px;
    }

    .pp-search-tab:first-child,
    .pp-search-tab:nth-child(2) {
        clip-path: none;
        margin-left: 0;
        border-radius: 10px 10px 0 0;
    }

    .pp-search-tab svg {
        width: 21px;
        height: 21px;
    }

    .pp-search-card {
        padding: 22px 18px;
        border-radius: 0 0 12px 12px;
    }

    .pp-form-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 14px;
    }

    .pp-field-submit {
        grid-column: 1 / -1;
    }

    .pp-field-submit .pp-submit-spacer {
        display: none;
    }

    .pp-search-footer {
        flex-wrap: wrap;
        gap: 10px;
    }

    .pp-dimension-help {
        flex-direction: column;
        align-items: flex-start;
        padding: 15px;
    }

    .pp-vehicle-search {
        flex-direction: column;
        align-items: flex-start;
    }

    .pp-vehicle-back {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .pp-hero {
        padding-top: 32px;
    }

    .pp-hero-heading h1 {
        font-size: 32px;
    }

    .pp-hero-top {
        margin-bottom: 25px;
    }

    .pp-search-tab span {
        line-height: 1.4;
        text-align: left;
    }

    .pp-form-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .pp-field select {
        font-size: 11px;
        padding: 0 8px;
        height: 48px;
    }

    .pp-field label {
        font-size: 11px;
    }

    .pp-search-submit {
        height: 50px;
    }

    .pp-trust-bar {
        padding: 23px 0;
    }

    .pp-trust-grid {
        gap: 18px 0;
    }

    .pp-trust-item {
        align-items: flex-start;
        padding: 0 10px;
        gap: 8px;
    }

    .pp-trust-item h3 {
        font-size: 10px;
    }

    .pp-trust-item p {
        font-size: 9px;
    }

    .pp-trust-icon {
        width: 27px;
        height: 27px;
    }
}

@media (prefers-reduced-motion: reduce) {

    .pp-search-submit,
    .pp-search-submit svg,
    .pp-search-tab,
    .pp-field select {
        transition: none;
    }
}
</style>
